export default __webpack_public_path__ + "static/rewards-6770959c1471e47f91348ad824ecba91.svg";